import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { store, persistor } from "./redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { LocationProvider } from "./hooks/LocationContext";
const GOOGLE_CLIENT_ID = "370045906644-48aiefvbktinclqvi408q5a5fk2o34jc.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
      <LocationProvider>
        <App />
        </LocationProvider>
      </BrowserRouter>
      </GoogleOAuthProvider>
      
      
    </PersistGate>
    
  </Provider>
);
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>
// );